import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3AntiRefluxSettings, V3DevicePCCSettings } from 'ngx-modbus';

export const ANTI_REFLUX_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'anti-reflux-settings',
  name: 'Anti-Reflux & PCC Settings',
  sections: [
    {
      id: 'anti-reflux',
      labelKey: 'antiRefluxSettings',
      registerTable: 'V3AntiRefluxSettings',
      fields: [
        fieldRef(V3AntiRefluxSettings, 'AntiReflux_Control'),
        fieldRef(V3AntiRefluxSettings, 'AntiReflux_Power', {
          visibleWhen: { field: 'AntiReflux_Control', value: 0, operator: 'neq' },
        }),
      ],
    },
    {
      id: 'pcc-sample-mode',
      labelKey: 'PCCSampleMode',
      registerTable: 'V3DevicePCCSettings',
      fields: [
        fieldRef(V3DevicePCCSettings, 'PCCSampleMode'),
      ],
    },
  ],
};
